import { Expose } from "class-transformer";

export class City {
  @Expose({ name: "cityName" })
  CityName: string;

  @Expose({ name: "cityId" })
  CityId: string;

  @Expose({ name: "code" })
  Code: string;

  @Expose({ name: "label" })
  Label?: string;

  @Expose({ name: "value" })
  Value?: string;

  constructor(cityName: string, cityId: string, code: string) {
    this.CityName = cityName;
    this.CityId = cityId;
    this.Code = code;
  }
}
